import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const myVariant = {
    hidden: {
        opacity: 0,
       y:100, 
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring",
            duration: 2.5,
            damping: 20,
            stiffness: 150
        }
    }
}

const Myprojects = ({setCursorVariant,setMessage}) => {

    

    return (
        <div className="container">
            
            <div className='Myprojects row mt-5' >
                <div className="col-lg-6 overflow-hidden">
                    <h1 className=' about-p m-3'>my projects</h1>
                    {/* <h1 className='m-3'>e-commerce </h1> */}
                    <motion.div className='card my-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                        <div className="overlay">
                            
                            <img className='card-img-top' src={require('../images/promptopia/Screenshot (54).png')} alt="" />
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">fullstack "NEXT.JS" app ,with google authentication you can add ai prompts,update and delete.</motion.div>
                        </div>
                        <div className="card-body">
                            {/* <h2 className="card-title">Promptopia</h2> */}
                            <Link to='https://promptopia-osn9vll0r-neteroabdelrahman.vercel.app/' target='_blank' className=' opener' onMouseEnter={() => {
                                setCursorVariant("live")
                                setMessage("live demo")
                            }} onMouseLeave={() => setCursorVariant("default")}>
                                <i className="fa-solid fa-up-right-from-square" ></i>
                            </Link>
                            <Link to='https://github.com/NETEROabdelrahman/Promptopia' target='_blank' className=' git-opener' onMouseEnter={() => {
                                setCursorVariant("liveGit")
                                setMessage("git hub")
                            }} onMouseLeave={() => setCursorVariant("default")}><i className="fa-brands fa-github" ></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">fullstack "MERN" hotel booking app , with full CRUD operation Admin panel.</motion.div>

                            <img className='card-img-top' src={require('../images/booking/Screenshot (53).png')} alt="" />
                        </div>
                        <div className="card-body">
                            {/* <h2 className="card-title">hotel booking</h2> */}
                            <Link to='https://adel-website-booking-app.netlify.app/' target='_blank' className=' opener' onMouseEnter={() => {
                                setCursorVariant("live")
                                setMessage("live demo")
                            }} onMouseLeave={() => setCursorVariant("default")}>
                                <i className="fa-solid fa-up-right-from-square" ></i>
                            </Link>
                            <Link to='https://github.com/NETEROabdelrahman/booking-app-frontend' target='_blank' className=' git-opener' onMouseEnter={() => {
                                setCursorVariant("liveGit")
                                setMessage("git hub")
                            }} onMouseLeave={() => setCursorVariant("default")}><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    
                </div>
                <div className="col-lg-6 overflow-hidden">
                    <motion.div className='card my-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">e-commerce phone store , you can choose the phone you want to buy and add it to the cart.</motion.div>

                            <img className='card-img-top' src={require('../images/Avion/Screenshot (61).png')} alt="avion" />
                        </div>
                        <div className="card-body">
                            {/* <h2 className="card-title">e-commerce phone store</h2> */}
                            <Link target='_blank' to='https://avion-front-end.vercel.app/' className=' opener' onMouseEnter={() => {
                                setCursorVariant("live")
                                setMessage("live demo")
                            }} onMouseLeave={() => setCursorVariant("default")}>
                                <i className="fa-solid fa-up-right-from-square" ></i>
                            </Link>
                            <Link to='https://github.com/NETEROabdelrahman/Avion-Front-end' target='_blank' className=' git-opener' onMouseEnter={() => {
                                setCursorVariant("liveGit")
                                setMessage("git hub")
                            }} onMouseLeave={() => setCursorVariant("default")}><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card ' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">a clone of netflix , full stack "MERN" website.</motion.div>

                            <img className='card-img-top' src={require('../images/netflix/Screenshot (51).png')} alt="" />
                        </div>
                        <div className="card-body">
                            {/* <h2 className="card-title">netflix clone</h2> */}
                            <Link to='https://adel-website-netflix-clone.netlify.app/' target='_blank' className=' opener' onMouseEnter={() => {
                                setCursorVariant("live")
                                setMessage("live demo")
                            }} onMouseLeave={() => setCursorVariant("default")} >
                                <i className="fa-solid fa-up-right-from-square"  ></i>
                            </Link>
                            <Link to='https://github.com/NETEROabdelrahman/Netflix-Clone' target='_blank' className=' git-opener' onMouseEnter={() => {
                                setCursorVariant("liveGit")
                                setMessage("git hub")
                            }} onMouseLeave={() => setCursorVariant("default")}><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className="link" whileHover={{ scale: 1.2 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                        <Link to="/my-works">view all projects </Link>
                    </motion.div>
                </div>
                
            </div>
        </div>
    );
}

export default Myprojects
